import React, {FC} from "react";
import {Dialog, DialogContent} from "@material-ui/core";
import {FeOrder, WorkerDay} from "../../../orders/redux/types";
import {CalendarDayDialogAvailability} from "./CalendarDayDialogAvailability";
import {CalendarDayDialogOrders} from "./CalendarDayDialogOrders";
import {makeStyles} from "@material-ui/core/styles";
import {isBefore, subDays} from "date-fns";
import {NextAppointmentForm} from "../../../workerApp/order/NextAppointmentForm";

const useStyles = makeStyles((theme) => ({
    dialogContainer: {
        backgroundColor: theme.palette.background.default,
    }
}));

interface CalendarDayDialogProps {
    open: boolean;
    toggleDialog: () => void;
    workerDay: WorkerDay;
    withNextAppointmentButton?: boolean;
    oldOrder?: FeOrder;
    dayDate: Date;
}

export const CalendarDayDialog: FC<CalendarDayDialogProps> = ({
                                                                  open,
                                                                  workerDay,
                                                                  toggleDialog,
                                                                  withNextAppointmentButton,
                                                                  oldOrder,
                                                                  dayDate
                                                              }) => {
    const classes = useStyles();
    const filteredOrders = workerDay.orders.filter(o => o.confirmed && !o.cancellation);
    const hasOrders = filteredOrders.length > 0;
    const isMorThanTwoDaysBefore = workerDay.availability && isBefore(new Date(), subDays(workerDay.availability.from, 2));

    return (
        <React.Fragment>
            <Dialog open={open} onClose={toggleDialog} classes={{paper: classes.dialogContainer}}>
                {workerDay.availability &&
                <CalendarDayDialogAvailability
                    availability={workerDay.availability}
                    showActions={!hasOrders && Boolean(isMorThanTwoDaysBefore)}
                    cardProps={{style: {marginBottom: !hasOrders ? 16 : 0}}}
                />}
                {hasOrders &&
                <CalendarDayDialogOrders
                    orders={filteredOrders}
                />}
                {withNextAppointmentButton && oldOrder &&
                <DialogContent style={{paddingBottom: 24}}>
                    <NextAppointmentForm oldOrder={oldOrder} dayDate={dayDate} workerDay={workerDay} onFinish={toggleDialog}/>
                </DialogContent>}
            </Dialog>
        </React.Fragment>
    )
}
